import { render, staticRenderFns } from "./PricingRadar.vue?vue&type=template&id=7af3e7bb&"
import script from "./PricingRadar.vue?vue&type=script&lang=js&"
export * from "./PricingRadar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports